import PropTypes from "prop-types";
import StepIndicatorIcon from "../../icons/StepIndicatorIcon";
import CompletedStepIcon from "../../icons/CompletedStepIcon";
import { styled } from "@mui/material";

const StepIconRoot = styled("div")(({ theme, ownerState }) => ({
  display: "flex",
  alignItems: "center",
}));

export default function StepIcon({ active, completed, className }) {
  return (

    // <StepIconRoot ownerState={{ active }} className={className}   sx={{backgroundColor:active?"var(--blue50)":"",padding:active?"5px":""}}>
    //   {completed ? <CompletedStepIcon /> : <StepIndicatorIcon />}
    // </StepIconRoot>

    <StepIconRoot ownerState={{ active }} className={className} sx={{boxShadow: active ? "0px 0px 2px 3px var(--orange50)" : "",borderRadius: "20px"}}>
      {completed ? <CompletedStepIcon width={active ? "38px" : "24px"} /> : <StepIndicatorIcon width={active ? "38px" : "24px"} />}
    </StepIconRoot>

  );
}

StepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};
